<account-menu [selectedMenu]="3" [me]="me"></account-menu>

<div class="col-lg-9 col-md-9 col-sm-8 content-panel-wrapper">

  <h2 class="page-title">Contracts</h2>

  <div class="clear"></div>

  <div class="col-lg-8 col-md-10 col-sm-12 col-lg-offset-2 col-md-offset-1 col-sm-offset-0 no-padding-mobile">
    <div class="panel">
      <div class="push-down-10">
        <div class="panel-legend">
          <div class="col-md-4 col-sm-12"><div class="panel-legend-inner"><span>1 credit </span> <strong>25 mins</strong></div></div>
          <div class="col-md-4 col-sm-12"><div class="panel-legend-inner"><span>2 credits</span> <strong>50 mins</strong></div></div>
          <div class="col-md-4 col-sm-12"><div class="panel-legend-inner"><span>3 credits</span> <strong>80 mins</strong></div></div>
        </div>
      </div>

      <div class="clear"></div>
    </div>
  </div>

  <div class="clear"></div>

  <!-- No Contracts -->
  <div class="col-sm-12 nopadding-mobile" *ngIf="active.length === 0">
    <div class="panel">
      <div class="panel-title">Current Contract</div>

      <div class="panel-sub-title-alt"><strong>You Currently have no active contracts</strong></div>

      <div class="col-md-8 col-sm-10 col-md-offset-2 col-sm-offset-1 panel-content centered">
        Please get in touch to arrange a new contract
      </div>

      <div class="clear"></div>
    </div>
  </div>

  <!-- Current Contract -->
  <div class="col-sm-12 nopadding" *ngIf="active.length > 0">
    <div class="panel">
      <div class="panel-title">Current Contract</div>

      <div class="col-sm-12">
        <div class="profile-sec-wrap">
          <div class="col-sm-12 nopadding">
            <div class="col-md-4 col-sm-4 col-xs-5">Purchased</div>

            <div class="col-md-4 col-sm-4 col-xs-3">Used</div>

            <div class="col-md-4 col-sm-4 col-xs-4">Expiry</div>

            <div class="clear"></div>

            <!-- Repeat per Membership -->
            <div class="col-sm-12 nopadding" *ngFor="let item of active">
              <div class="profile-content-alt">
                <div class="col-md-4 col-sm-4 col-xs-5">
                  <div class="mb-table-lg">{{item.totalPurchased}}</div>
                </div>

                <div class="col-md-4 col-sm-4 col-xs-3">
                  <div class="mb-table-lg">{{item.total25Issued + item.total50Issued + item.total80Issued}}</div>
                </div>

                <div class="col-md-4 col-sm-4 col-xs-4">
                  <div class="mb-table-lg">{{item.expiryDate | date:'dd/MM/yyyy'}}</div>
                </div>

                <div class="clear"></div>
              </div>
            </div>

            <div class="clear"></div>
          </div>

          <div class="clear"></div>
        </div>

        <div class="clear"></div>
      </div>

      <div class="clear"></div>
    </div>
  </div>

  <!-- Expired Contract -->
  <div class="col-sm-12 nopadding" *ngIf="expired.length > 0">
    <div class="panel">
      <div class="panel-title">Expired Contract</div>

      <div class="col-sm-12">
        <div class="profile-sec-wrap">
          <div class="col-sm-12 nopadding">
            <div class="">
              <div class="col-md-4 col-sm-4 col-xs-5">
                <div class="">Purchased</div>
              </div>

              <div class="col-md-4 col-sm-4 col-xs-3">
                <div class="">Used</div>
              </div>

              <div class="col-md-4 col-sm-4 col-xs-4">
                <div class="">Expired On</div>
              </div>

              <div class="clear"></div>
            </div>
          </div>

          <!-- Repeat per elapsed membership -->
          <div class="col-sm-12 nopadding" *ngFor="let item of expired">
            <div class="profile-content-alt">
              <div class="col-md-4 col-sm-4 col-xs-5">
                <div class="mb-table-lg">{{item.totalPurchased}}</div>
              </div>

              <div class="col-md-4 col-sm-4 col-xs-3">
                <div class="mb-table-lg">{{item.total25Issued + item.total50Issued + item.total80Issued}}</div>
              </div>

              <div class="col-md-4 col-sm-4 col-xs-4">
                <div class="mb-table-lg">{{item.expiryDate | date:'dd/MM/yyyy'}}</div>
              </div>

              <div class="clear"></div>
            </div>
          </div>

          <div class="clear"></div>
        </div>
      </div>

      <div class="clear"></div>
    </div>
  </div>
</div>
